import React from 'react';
import { Grid, GridSpacing } from '@mui/material';

export type FormType = React.FormEvent<HTMLFormElement>;

export interface FormProps {
    className?: string;
    sx?: React.CSSProperties | undefined;
    spacing?: GridSpacing | undefined;
    onSubmit: (e: FormType) => void;
}

export const Form: React.FC<FormProps> = React.memo(
    ({ className, sx, onSubmit, spacing, children }) => (
        <form
            onSubmit={onSubmit}
            className={className}
            style={sx ? sx : { width: '100%' }}
        >
            <Grid container spacing={spacing ? spacing : 3}>
                {children}
            </Grid>
        </form>
    )
);
